// extracted by mini-css-extract-plugin
module.exports = {"item":"CarouselItem_item__13K2v","image":"CarouselItem_image__2N0Bg","description":"CarouselItem_description__30-BH"};